export default {
	headerSearch: {
  "preferences": "Theme and language",
  "collapsed": "Search…",
  "open": "Search people and guides",
  "placeholder": "Consulente, medium or guide…",
  "hint": "Enter at least 2 characters.",
  "empty": "No results found.",
  "error": "Some results could not be loaded. Please try again.",
  "limit": "Up to 5 results per category. Refine the name to find more.",
  "primaryMedium": "Primary medium: {name}",
  "noPrimary": "No primary medium",
  "consulente": "Consulente",
  "medium": "Medium",
  "guide": "Guide"
},
	active: "Active",
	inactive: "Inactive",
	status: "Status",
	actions: "Actions",
	notFinished: "Not finished",
	save: "Save",
	cancel: "Cancel",
	edit: "Edit",
	delete: "Delete",
	create: "Create",
	update: "Update",
	add: "Add",
	change: "Change",
	remove: "Remove",
	typeToSearch: "Type to search",
	years: "years",
	search: "Search",
	searchField: "Search",
	filter: "Filter",
	loading: "Loading...",
	back: "Back",
	confirmDelete: "Confirm deletion",
	createdAt: "Created at",
	notSpecified: "Not specified",
	unknown: "Unknown",
	unnamed: "Unnamed",
	view: "View",
	details: "Details",
	close: "Close",
	yes: "Yes",
	no: "No",
	invalidValue: "Invalid value",
	activate: "Activate",
	all: "All",
	complete: "Complete",
	confirm: "Confirm",
	createdBy: "Created by",
	deactivate: "Deactivate",
	description: "Description",
	endedAt: "Ended at",
	error: "Error performing operation",
	errorLoading: "Error loading data",
	errorSaving: "Error saving data",
	lastUpdate: "Last update",
	loadMore: "Load more",
	next: "Next",
	notes: "Notes",
	optional: "optional",
	print: "Print",
	required: "Required field",
	saved: "Saved successfully",
	showActiveOnly: "Show active only",
	showLess: "Show less",
	showMore: "Show more",
	since: "Since",
	start: "Start",
	timestamps: "System Dates",
	viewDetails: "View Details",
};
